import styled from "styled-components";

import { JobCardSection } from "./JobCardSection";

import { Job } from "@otta/search/schema";
import { Icon } from "@otta/icons";
import { Text, media } from "@otta/design";
import { modularScale, palette } from "@otta/design-tokens";

export type TeamProps = {
  team: NonNullable<Pick<Job.Fragment, "team">["team"]>;
};

const Content = styled.div`
  flex-direction: column;
  padding-top: 0.5rem;
  display: flex;
  gap: 1.5rem;
`;

const MissionCard = styled.div`
  display: flex;
  background: ${palette.grayscale.shade100};
  flex-direction: column;
  border-radius: 0.5rem;
  padding: 1rem;
  gap: 0.5rem;
`;

const IconHack = styled.span`
  font-size: ${modularScale(2.5)};
  margin-bottom: -0.2rem;
  margin-top: 0.2rem;
`;

const FlexText = styled(Text)`
  align-items: center;
  display: flex;
  gap: 0.5rem;
`;

function TeamSize({
  size,
  className,
}: {
  size: number | null;
  className?: string;
}): React.ReactElement | null {
  return size !== null ? (
    <FlexText size={-1} bold data-testid="team-size" className={className}>
      <IconHack>
        <Icon icon="users" />
      </IconHack>
      {size === 1 ? "1 person" : `${size} people`}
    </FlexText>
  ) : null;
}

const MobileTeamSize = styled(TeamSize)`
  ${media({ from: "tablet" })`display: none;`}
`;

const DesktopTeamSize = styled(TeamSize)`
  ${media({ from: "tablet" })`display: flex;`}
  display: none;
`;

function Mission({ team: { mission } }: TeamProps): React.ReactElement | null {
  return mission ? (
    <MissionCard>
      <Text as="h4" bold>
        Our mission
      </Text>
      {mission}
    </MissionCard>
  ) : null;
}

export function MeetTheTeamSection({ team }: TeamProps): React.ReactElement {
  return (
    <JobCardSection
      title={`Meet the ${team.name}`}
      TopRightComponent={<DesktopTeamSize size={team.size} />}
    >
      <Content data-testid="mtt-content">
        <MobileTeamSize size={team.size} />
        <Mission team={team} />
      </Content>
    </JobCardSection>
  );
}
